import { TemplateDefLink, TemplateDefOptions } from '@iot-platform/models/common';
import { get } from 'lodash';
import moment from 'moment';
import { GetUtils } from './get.utils';

export class TemplateDefUtils {
  static objectValuePredicate = ({ value }: Pick<TemplateDefOptions, 'value'>): unknown => {
    const values = value ? Object.values(value) : [];
    return values?.length ? values[0] : null;
  };

  static concatPredicate = ({ element, def }: Pick<TemplateDefOptions, 'element' | 'def'>): unknown =>
    def.attrKeys.map((key: string) => GetUtils.get(element, key, '')).join(def.separator);

  static booleanPredicate = ({ value }: Pick<TemplateDefOptions, 'value'>): string => (value ? 'IOT_DICTIONARY.YES' : 'IOT_DICTIONARY.NO');

  static timeFormatPredicate = ({ value }: Pick<TemplateDefOptions, 'value'>): string => moment(value * 1000).format('YYYY-MM-DD HH:mm:ss');

  static dateFormatPredicate = ({ value }: Pick<TemplateDefOptions, 'value'>): string =>
    moment(value).isValid() ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';

  static shortDateFormatPredicate = ({ value }: Pick<TemplateDefOptions, 'value'>): string =>
    moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : '-';

  static longDateFormatPredicate = ({ value }: Pick<TemplateDefOptions, 'value'>) => moment(value).format('LL');

  static getQueryParams = ({ data, def }: { data: unknown; def: Partial<TemplateDefLink> }) => TemplateDefLink.getQueryParams({ data, def });

  static getPathParams = ({ data, def }: { data: unknown; def: Partial<TemplateDefLink> }) => TemplateDefLink.getPathParams({ data, def });

  static getParams = ({ def }: { def: Partial<TemplateDefLink> }) => TemplateDefLink.getParams({ def });

  static hasParams = ({ data, def }: { data: unknown; def: Partial<TemplateDefLink> }): boolean => {
    const values = this.getParams({ def })
      .map(({ attr }) => get(data, attr))
      .filter((value: string) => value !== null && value !== undefined);
    return !!values.length;
  };

  static trimPredicate = ({ value }: Pick<TemplateDefOptions, 'value'>) => value?.toString()?.trim() ?? null;
}
